$(document).ready(function () {
  if ($(window).width() < 767) {
    $(".cstm-slider-collection").slick({
      arrows: false,
      centerMode: true,
      centerPadding: "30px",
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: { 
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }


    if ($(window).width() < 767) {
    $(".ast_announce.swiper-wrappe").slick({
      arrows: false,
      autoplay: true,
      centerMode: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }


    // $(".ast_announce").slick({
    //   arrows: false,
    //   infinite: true,
    //   slidesToShow:2,

    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: { 
    //         slidesToShow: 2,
    //         slidesToScroll: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // });
  

  if ($(window).width() < 767) {
    $(".reccomend-slider-collection").slick({
      arrows: false,
      centerMode: true,
      centerPadding: "30px",
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  // ============================================== MultiStep Form JS ==============================================
  let SelectedValueArr = [];
  let LowPriorityProducts = [];
  let CurrentFormIndex = 0;
  let PrevFormIndex = 0;
  let MainProductData = [];
  // ============= adding Roast-Level img name =============
  $("#RoastPreference-form .form-option").each(function () {
    $(this).find("label img").attr("data-imgname",$(this).find("input[type=radio]").val().toLowerCase());
  });
  
  $("#RoastPreference-form .form-option").each(function (i) {
    let roastImgName = $(this).find("input[type=radio]").val().toLowerCase();
    $(".Single-Favourite-product-container").each(function () {
      if ($(this).find(".product-specifications .specification-img .roast-level-images").eq(i).html() != undefined){
        $(this).find(".product-specifications .specification-img .roast-level-images").eq(i).find("img").attr("data-imgname", roastImgName);
      }
    });
  });
  
  // ======================= Display Favourite Choice Product =======================
  function DisplayProduct() {
    let DataArr = JSON.parse(localStorage.getItem("MainProductData"))
  
    if (DataArr != null && DataArr.length != 0) {
      // console.log("ProductItems",DataArr)
      console.log("yes")
      let SelectedValueOptions = DataArr[0].SelectedValueOptions
      let ProductIndex = DataArr[1].FavProductIndex
      let RecommendedProduct = DataArr[2];
      
      let rec_productOne = $(`.Single-Favourite-product-container[data-index=${RecommendedProduct.firstProduct}]`).find('.product-card').html();
      let rec_productTwo = $(`.Single-Favourite-product-container[data-index=${RecommendedProduct.secondProduct}]`).find('.product-card').html();
      $('.Recommended-Product_container').append(`<div class="product-card">${rec_productOne}</div>`);
      $('.Recommended-Product_container').append(`<div class="product-card">${rec_productTwo}</div>`);
        
      $(".MultiStep-Form-Wrapper .Form-container").each(function () {
        $(this).hide();
      })
        
      if( ($(`.Single-Favourite-product-container[data-index=${ProductIndex}]`).html() != '') || 
          ($(`.Single-Favourite-product-container[data-index=${ProductIndex}]`).html() != undefined) ) {
        $(".Favourite-Product-Container-upper").show();
        let singleProduct = $(`.Single-Favourite-product-container[data-index=${ProductIndex}]`);
        singleProduct.css("display", "flex");
        
        singleProduct.find(".product-specifications .tasting_notes p").text(SelectedValueOptions[3])
        singleProduct.find(".product-specifications .roast_level p").text(SelectedValueOptions[2])
        let sipping_style_value = '';
        if(SelectedValueOptions[1] == 'cream'){
          sipping_style_value = 'Milk or Cream' ;
        }else if(SelectedValueOptions[1] == 'no cream'){
            sipping_style_value = 'I take it black' ;
        }
        singleProduct.find(".product-specifications .sipping_style p").text(sipping_style_value)
        singleProduct.find(".product-specifications .brew_methods p").text(SelectedValueOptions[0])
        if(SelectedValueOptions[6] != undefined){
          singleProduct.find(".product-specifications .sipping_style p").append(', ' + SelectedValueOptions[6])
        }
        
        singleProduct.find(".product-specifications .specification-img .roast-level-images").each(function () {
            if ($(this).find("img").attr("data-imgname") == SelectedValueOptions[2].toLowerCase()) {
              $(this).show();
            }
          });
        
        $("#CoffeeType-form .form-options-Wrapper .form-option").each(function () {
            if ($(this).find("input").val() == SelectedValueOptions[1]) {
              let imgSrc = $(this).find("label img").attr("src");
              singleProduct.find(".product-specifications .sipping_style .specification-img").html(`<img src="${imgSrc}" alt="${imgSrc}">`);
            }
          }
        );
        
        $("#CoffeeMaker-form .form-options-Wrapper .form-option").each(function () {
            if ($(this).find("input").val() == SelectedValueOptions[0]) {
              let imgSrc = $(this).find("label img").attr("src");
              singleProduct.find(".product-specifications .brew_methods .specification-img").html(`<img src="${imgSrc}" alt="${imgSrc}">`);
            }
          }
        );
      }
      // =============== Show Recommended Products ===============
      $(".Recommended-Product-Container-Upper").css("display", "flex");
    }
    else{
      $('#FormIndexBtns').show();
    }
  }
  DisplayProduct();

  $(".Multistep-form .Form-container").eq(CurrentFormIndex).addClass("showForm");
  
  $("#FormIndexBtns >div span").each(function () {
    $(this).removeClass("activeIndexBtn");
  });
  $("#FormIndexBtns span").eq(CurrentFormIndex).addClass("activeIndexBtn");

  
  // ============================ Selecting Coffee Choices ============================
  $("#CoffeeMaker-form input[type=radio]").click(function () {
    if ($("#CoffeeMaker-form input[type=radio]:checked").length > 0) {
      PrevFormIndex = 0;
      CurrentFormIndex = 1;
      $(this).parents(".Form-container").attr("data-value",$("#CoffeeMaker-form input[type=radio]:checked").val());
      let ClickedIndex = $(this).parents(".form-option").index();
      $("#CoffeeMaker-form .form-option").each(function (i) {
        if (i != ClickedIndex) {
          $(this).find("label").addClass("deactiveInput");
        } else {
          $(this).find("label").removeClass("deactiveInput");
        }
      });
      $("#FormIndexBtns span").eq(PrevFormIndex).addClass("enabledIndexBtn");
      $("#FormIndexBtns >div span").each(function () {
        $(this).removeClass("activeIndexBtn");
      });
      $("#FormIndexBtns span").eq(CurrentFormIndex).addClass("activeIndexBtn");
      $(".Multistep-form .Form-container").eq(PrevFormIndex).removeClass("showForm");
      $(".Multistep-form .Form-container").eq(CurrentFormIndex).addClass("showForm");
    }
  });
  $('#CoffeeType-form .form-option:nth-child(1) label').addClass('rightBorderUnset');
  $("#CoffeeType-form input[type=radio]").click(function () {
    if ($("#CoffeeType-form input[type=radio]:checked").length > 0) {
      let ClickedIndex = $(this).parents(".form-option").index();
      $("#CoffeeType-form .form-option").each(function (i) {
        if (i != ClickedIndex) {
          $(this).find("label").addClass("deactiveInput");
        } else {
          $(this).find("label").removeClass("deactiveInput");
        }
      });
      
      if($('#CoffeeType-form .form-option:nth-child(1) label').html() == $(this).siblings('label').html()){
        $(this).siblings('label').removeClass('rightBorderUnset');
        $(this).parents('.form-option').siblings('.form-option').find('label').addClass('leftBorderUnset');
      }else if($('#CoffeeType-form .form-option:nth-child(2) label').html() == $(this).siblings('label').html()){
        $(this).siblings('label').removeClass('leftBorderUnset');
        $(this).parents('.form-option').siblings('.form-option').find('label').addClass('rightBorderUnset');
      }
      $("#CoffeeType-form .AddSugarOrNot").css("display", "block");
      $("#CoffeeType-form .ContinueBtn").css("display", "block");
    }
  });
  $("#CoffeeType-form .ContinueBtn span").click(function () {
    PrevFormIndex = 1;
    CurrentFormIndex = 2;
    $(this).parents(".Form-container").attr("data-value",$("#CoffeeType-form input[type=radio]:checked").val());
    $("#FormIndexBtns span").eq(PrevFormIndex).addClass("enabledIndexBtn");
    $("#FormIndexBtns >div span").each(function () {
      $(this).removeClass("activeIndexBtn");
    });
    $("#FormIndexBtns span").eq(CurrentFormIndex).addClass("activeIndexBtn");
    $(".Multistep-form .Form-container").eq(PrevFormIndex).removeClass("showForm");
    $(".Multistep-form .Form-container").eq(CurrentFormIndex).addClass("showForm");
  });
  
  $("#RoastPreference-form input[type=radio]").click(function () {
    if ($("#RoastPreference-form input[type=radio]:checked").length > 0) {
      PrevFormIndex = 2;
      CurrentFormIndex = 3;
      $(this).parents(".Form-container").attr("data-value",$("#RoastPreference-form input[type=radio]:checked").val());
      let ClickedIndex = $(this).parents(".form-option").index();
      $("#RoastPreference-form .form-option").each(function (i) {
        if (i != ClickedIndex) {
          $(this).find("label").addClass("deactiveInput");
        } else {
          $(this).find("label").removeClass("deactiveInput");
        }
      });
      $("#FormIndexBtns span").eq(PrevFormIndex).addClass("enabledIndexBtn");
      $("#FormIndexBtns >div span").each(function () {
        $(this).removeClass("activeIndexBtn");
      });
      $("#FormIndexBtns span").eq(CurrentFormIndex).addClass("activeIndexBtn");
      $(".Multistep-form .Form-container").eq(PrevFormIndex).removeClass("showForm");
      $(".Multistep-form .Form-container").eq(CurrentFormIndex).addClass("showForm");
      $("#RoastPreference-form input[type=radio]").each(function () {
        $(this).siblings("label").removeClass("CoffeeTaste-form-activeInput");
      });
      $("#RoastPreference-form input[type=radio]:checked").each(function () {
        $(this).siblings("label").addClass("CoffeeTaste-form-activeInput");
      });
    }
  });
  
  $("#CoffeeTaste-form input[type=checkbox]").click(function () {
    if ($("#CoffeeTaste-form input[type=checkbox]:checked").length == 3) {
      $("#CoffeeTaste-form :not(input[type=checkbox]:checked)").each(function () {
          $(this).attr("disabled", true);
          $(this).siblings("label").addClass("deactiveInput");
      });
    } else if ($("#CoffeeTaste-form input[type=checkbox]:checked").length < 3) {
        $("#CoffeeTaste-form :not(input[type=checkbox]:checked)").each(function () {
            $(this).removeAttr("disabled");
            $(this).siblings("label").removeClass("deactiveInput");
        });
    }
    if ($("#CoffeeTaste-form input[type=checkbox]:checked").length > 0 && $("#CoffeeTaste-form input[type=checkbox]:checked").length < 4) {
      $("#CoffeeTaste-form :not(input[type=checkbox]:checked)").each(
        function () {
          $(this).siblings("label").find(".CorrectIcon").css("display", "none");
          $(this).siblings("label").find("img").css("display", "inline");
        }
      );
      $("#CoffeeTaste-form input[type=checkbox]:checked").each(function () {
        $(this).siblings("label").find("img").css("display", "none");
        $(this).siblings("label").find(".CorrectIcon").css("display", "flex");
      });
      $("#CoffeeTaste-form input[type=checkbox]").each(function () {
        $(this).siblings("label").removeClass("CoffeeTaste-form-activeInput");
      });
      $("#CoffeeTaste-form input[type=checkbox]:checked").each(function () {
        $(this).siblings("label").addClass("CoffeeTaste-form-activeInput");
      });
      $("#CoffeeTaste-form .ContinueBtn").css("display", "block");
    } else if ($("#CoffeeTaste-form input[type=checkbox]:checked").length == 0) {
      $("#CoffeeTaste-form :not(input[type=checkbox]:checked)").each(
        function () {
          $(this).siblings("label").removeClass("CoffeeTaste-form-activeInput");
          $(this).siblings("label").find(".CorrectIcon").css("display", "none");
          $(this).siblings("label").find("img").css("display", "inline");
          $("#CoffeeTaste-form .ContinueBtn").css("display", "none");
        }
      );
    }
  });
  $("#CoffeeTaste-form .ContinueBtn span").click(function () {
       $(window).scrollTop(0);
    PrevFormIndex = 3;
    CurrentFormIndex = 4;
    let CheckedValues = [];
    $("#CoffeeTaste-form input[type=checkbox]:checked").each(function () {
      CheckedValues.push($(this).val());
      $(this).parents(".Form-container").attr("data-value", CheckedValues);
    });
    $("#FormIndexBtns span").eq(PrevFormIndex).addClass("enabledIndexBtn");
    $("#FormIndexBtns >div span").each(function () {
      $(this).removeClass("activeIndexBtn");
    });
    $("#FormIndexBtns span").eq(CurrentFormIndex).addClass("activeIndexBtn");
    $(".Multistep-form .Form-container").eq(PrevFormIndex).removeClass("showForm");
    $(".Multistep-form .Form-container").eq(CurrentFormIndex).addClass("showForm");
  });
  
  $('#TypicalCoffee-form .form-option:nth-child(1) label').addClass('rightBorderUnset');
  $("#TypicalCoffee-form input[type=radio]").click(function () {
    if ($("#TypicalCoffee-form input[type=radio]:checked").length > 0) {
      PrevFormIndex = 4;
      CurrentFormIndex = 5;
      $(this).parents(".Form-container").attr("data-value",$("#TypicalCoffee-form input[type=radio]:checked").val());
      let ClickedIndex = $(this).parents(".form-option").index();
      $("#TypicalCoffee-form .form-option").each(function (i) {
        if (i != ClickedIndex) {
          $(this).find("label").addClass("deactiveInput");
        } else {
          $(this).find("label").removeClass("deactiveInput");
        }
      });
      
      $("#FormIndexBtns span").eq(PrevFormIndex).addClass("enabledIndexBtn");
      $("#FormIndexBtns >div span").each(function () {
        $(this).removeClass("activeIndexBtn");
      });
      $("#FormIndexBtns span").eq(CurrentFormIndex).addClass("activeIndexBtn");
      $(".Multistep-form .Form-container").eq(PrevFormIndex).removeClass("showForm");
      $(".Multistep-form .Form-container").eq(CurrentFormIndex).addClass("showForm");
      
      if($('#TypicalCoffee-form .form-option:nth-child(1) label').html() == $(this).siblings('label').html()){
        $(this).siblings('label').removeClass('rightBorderUnset');
        $(this).parents('.form-option').siblings('.form-option').find('label').addClass('leftBorderUnset');
      }else if($('#TypicalCoffee-form .form-option:nth-child(2) label').html() == $(this).siblings('label').html()){
        $(this).siblings('label').removeClass('leftBorderUnset');
        $(this).parents('.form-option').siblings('.form-option').find('label').addClass('rightBorderUnset');
      }
    }
  });

  $("#CoffeeJourney-form input[type=radio]").click(function () {
    if ($("#CoffeeJourney-form input[type=radio]:checked").length > 0) {
      $(this)
        .parents(".Form-container")
        .attr(
          "data-value",
          $("#CoffeeJourney-form input[type=radio]:checked").val()
        );
      let ClickedIndex = $(this).parents(".form-option").index();
      $("#CoffeeJourney-form .form-option").each(function (i) {
        if (i != ClickedIndex) {
          $(this).find("label").addClass("deactiveInput");
        } else {
          $(this).find("label").removeClass("deactiveInput");
        }
      });
      $("#FormIndexBtns span").eq(5).addClass("enabledIndexBtn");
      $("#FormIndexBtns >div span").each(function () {
        $(this).removeClass("activeIndexBtn");
      });
      $("#FormIndexBtns span").eq(CurrentFormIndex).addClass("activeIndexBtn");
      $("#FormSubmit-Popup").show();

      // ================= Matching Product Options =================
      SelectedValueArr = [];
      $(".Form-container").each(function () {
        SelectedValueArr.push($(this).attr("data-value"));
      });
      if($("input#toAddSugarOrNot[type=checkbox]").is(":checked")){
        let addSugarText = $("input#toAddSugarOrNot[type=checkbox]:checked").siblings('label[for=toAddSugarOrNot]').text()
        SelectedValueArr.push(addSugarText);
      }
      // console.log("SelectedValueArr=", SelectedValueArr);
      
      let SelectedOptions = {SelectedValueOptions:SelectedValueArr}
      MainProductData.push(SelectedOptions);
      localStorage.setItem('MainProductData',JSON.stringify(MainProductData))
      
      let ProductIndexArr = [];
      $(".Single-Favourite-product-container").each(function () {
        let SpecificationMatchCount = 0;
        let tastingNotesVal = $(this).attr("data-tasting-notes");
        let roastLevelVal = $(this).attr("data-roast-level");
        let sippingStyleVal = $(this).attr("data-sipping-style");
        let brewMethodssVal = $(this).attr("data-brew-methods");
        if (tastingNotesVal != undefined || roastLevelVal != undefined || sippingStyleVal != undefined || brewMethodssVal != undefined) {
          let tastingNoteCount = 0;
          let tastingNoteArr = tastingNotesVal.split(",");
          tastingNoteArr.forEach((val, i) => {
            if (SelectedValueArr[3].toLowerCase().includes(val)) {
              tastingNoteCount++;
            }
          });
          if (tastingNoteCount >= 1) {
            SpecificationMatchCount++;
          }
          if (roastLevelVal.includes(SelectedValueArr[2].toLowerCase())) {
            SpecificationMatchCount++;
          }
          if (sippingStyleVal.includes(SelectedValueArr[1].toLowerCase())) {
            SpecificationMatchCount++;
          }
          if (brewMethodssVal.includes(SelectedValueArr[0].toLowerCase())) {
            SpecificationMatchCount++;
          }
           // console.log("COUNT==================",SpecificationMatchCount)
          // =============== Show Matched Products ===============
          if (SpecificationMatchCount >= 3) {
            let productIndexObj_withCount = {
              productIndex: $(this).attr("data-index"),
              matchedCount: SpecificationMatchCount,
            };
            ProductIndexArr.push(productIndexObj_withCount);
          } else if (SpecificationMatchCount >= 2) {
            let productIndexObj_withCount = {
              productIndex: $(this).attr("data-index"),
              matchedCount: SpecificationMatchCount,
            };
            ProductIndexArr.push(productIndexObj_withCount);
          } else if (SpecificationMatchCount >= 1) {
            let productIndexObj_withCount = {
              productIndex: $(this).attr("data-index"),
              matchedCount: SpecificationMatchCount,
            };
            ProductIndexArr.push(productIndexObj_withCount);
          }
        }
      });
      // =============== Checking max Product Count ===============
      function compareMatchedCount( b, a ) {
        if ( a.matchedCount < b.matchedCount ){
          return -1;
        }
        if ( a.matchedCount > b.matchedCount ){
          return 1;
        }
        return 0;
      }
      ProductIndexArr.sort( compareMatchedCount );
      // console.log("ProductIndexArr",ProductIndexArr);
      
      let IndexOfProduct = parseInt(ProductIndexArr[0].productIndex);
      let MatchedproductIndex = {FavProductIndex:IndexOfProduct}
      MainProductData.push(MatchedproductIndex);
      localStorage.setItem('MainProductData',JSON.stringify(MainProductData))
      

      // =============== Matching Recommended Products ===============
      let RecommendedProducts = []
      LowPriorityProducts = ProductIndexArr.filter(val=> IndexOfProduct != val.productIndex)
      LowPriorityProducts.forEach((product)=> {
        let rec_matchCount = 0;
        let brew_method = $(`.Single-Favourite-product-container[data-index=${parseInt(product.productIndex)}]`).attr('data-brew-methods')
        let tasting_notes = $(`.Single-Favourite-product-container[data-index=${parseInt(product.productIndex)}]`).attr('data-tasting-notes')
        if(SelectedValueArr[0].toLowerCase() == brew_method){
          rec_matchCount++;
        }
        let tastingNoteArr = tasting_notes.split(",");
        tastingNoteArr.forEach((val, i) => {
          if (SelectedValueArr[3].toLowerCase().includes(val)) {
            rec_matchCount++;
          }
        });
        RecommendedProducts.push({rec_productIndex:product.productIndex , rec_matchCount: rec_matchCount})
      })
      
      // =============== sort Recommended Products Count ===============
      let recProductObj = {}
      if(RecommendedProducts.length >= 2){
        function compareRec_ProductsCount( b, a ) {
          if ( a.rec_matchCount < b.rec_matchCount ){
            return -1;
          }
          if ( a.rec_matchCount > b.rec_matchCount ){
            return 1;
          }
          return 0;
        }
        RecommendedProducts.sort( compareRec_ProductsCount );
        // console.log("RecommendedProducts",RecommendedProducts);
        recProductObj = {
          firstProduct:parseInt(RecommendedProducts[0].rec_productIndex),
          secondProduct:parseInt(RecommendedProducts[1].rec_productIndex),
        }
      }
      else if(RecommendedProducts.length < 2 && RecommendedProducts.length >=0){
         let ReservedIndex = [IndexOfProduct,parseInt(RecommendedProducts[0].rec_productIndex)];
         let UnReservedIndex = []
         $('.Single-Favourite-product-container').each(function (i) {
           let IndexPresent = false
           if(!ReservedIndex.includes(i)){
             UnReservedIndex.push(i)
           }
         })
        function getRndInteger(min, max) {
          return Math.floor(Math.random() * (max - min)) + min;
        }
        let secRecommendedProduct = UnReservedIndex[0]
        if(UnReservedIndex.length >= 2){
          secRecommendedProduct = getRndInteger(UnReservedIndex[0],UnReservedIndex[UnReservedIndex.length-1])
          console.log("secRecommendedProduct",secRecommendedProduct)
        }
         recProductObj = {
          firstProduct:parseInt(RecommendedProducts[0].rec_productIndex),
          secondProduct:secRecommendedProduct,
         }
      }
      MainProductData.push(recProductObj);
      localStorage.setItem('MainProductData',JSON.stringify(MainProductData))
      DisplayProduct()
        
    }
  });
  $(".BackBtn").click(function () {
    $(".Multistep-form .Form-container")
      .eq(CurrentFormIndex)
      .removeClass("showForm");
    $(".Multistep-form .Form-container").eq(PrevFormIndex).addClass("showForm");
    $("#FormIndexBtns >div span").each(function () {
      $(this).removeClass("activeIndexBtn");
    });
    $("#FormIndexBtns >div span").eq(PrevFormIndex).addClass("activeIndexBtn");
    CurrentFormIndex = PrevFormIndex;
    if (PrevFormIndex > 0) {
      PrevFormIndex--;
    }
  });
  $("#FormIndexBtns >div span").click(function () {
    CurrentFormIndex = $(this).text() - 1;
    PrevFormIndex = $(this).text() - 2;
    if (
      $(".Form-container").eq(CurrentFormIndex).attr("data-value") !=
        undefined ||
      $(".Form-container")
        .eq(CurrentFormIndex - 1)
        .attr("data-value") != undefined
    ) {
      $("#FormIndexBtns >div span").each(function () {
        $(this).removeClass("activeIndexBtn");
      });
      $(this).addClass("activeIndexBtn");
      $(".Multistep-form .Form-container").each(function () {
        $(this).removeClass("showForm");
      });
      $(".Multistep-form .Form-container")
        .eq(CurrentFormIndex)
        .addClass("showForm");
    }
  });
  $("#TakeToCoffe").click(function () {
    $("#FormSubmit-Popup").hide();
    $(".MultiStep-Form-Wrapper").hide();
  });

  $("#CancelIcon").click(function () {
    $("#FormSubmit-Popup").hide();
    $(".MultiStep-Form-Wrapper").hide();
  });

  $(".Suggestion-Content-btn span").click(function () {
    let SuggestionText = $(this)
      .parents(".Suggestion-Content-btn")
      .siblings(".Suggestion-Content");
    if (SuggestionText.length) {
      $(this)
        .parents(".Suggestion-Content-btn")
        .siblings(".Suggestion-Content")
        .slideDown(250);
    }
  });
  $(".Hide-Suggestion-Content").click(function () {
    $(this).parents(".Suggestion-Content").fadeOut(250);
  });
  $(".popup-container .Email-Form .newsletter__submit").click(function () {
    location.reload();
  });
  $("#RetakeBtn").click(function () {
    localStorage.removeItem('MainProductData')
    location.reload();
  });

  
});

$(document).mouseup(function (e) {
  if ($(e.target).closest(".Suggestion-Content").length === 0) {
    $(".Suggestion-Content").fadeOut(250);
  }
});








  // Popup Show Function
  function showPopup() {
    document.getElementById('popup').style.display = 'block';
  }

  // Popup Close Function
  function closePopup() {
    document.getElementById('popup').style.display = 'none';

    // Set Cookie for 24 hours
    var now = new Date();
    var expireTime = now.getTime() + 24 * 60 * 60 * 1000; // 24 hours
    now.setTime(expireTime);
    document.cookie = 'popupShown=true; expires=' + now.toUTCString() + '; path=/';
  }

  // Check Cookie and Show Popup
  document.addEventListener('DOMContentLoaded', function() {
    var popupShown = getCookie('popupShown');
    console.log(popupShown);
    if (!popupShown) {
      setTimeout(()=>{
        showPopup();
      },8000)
      
    }
  });

  // Function to Get Cookie Value
  function getCookie(name) {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].split('=');
      if (cookie[0] === name) {
        return cookie[1];
      }
    }
    return null;
  }

  // Close Popup on Close Button Click

 // document.addEventListener('click', function(e) {
 //    if (e.target.classList.contains('popup_cross_btn')) {
 //      closePopup();
 //    }
 //  });
document.addEventListener('click', function(e) {
  var popup = document.getElementById('popup');
  
  
  // Check if the clicked element or its parent has the 'newsletter_popup_close' cpolass
  if (e.target.classList.contains('popup_cross_btn') || e.target.parentElement.classList.contains('popup_cross_btn')) {
    closePopup();
  }
});



$(document).ready(function () {
  if ($(window).width() < 767) {
 $("#block--slide_cWDHPQ ").removeClass("slideshow__desktop-layout--overlay");
  }

});


  